import { formatDate } from '@angular/common';
import { Component, OnInit ,Output,Input ,EventEmitter} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from "src/app/Services/common.service";
import { ExcelExportService } from 'src/app/Services/excel.service';
import { StorageService } from 'src/app/Services/storage.service';

@Component({
  selector: 'g10-vehicle-booking-history-reports',
  templateUrl: './vehicle-booking-history-reports.component.html',
  styleUrls: ['./vehicle-booking-history-reports.component.css']
})
export class VehicleBookingHistoryReportsComponent implements OnInit {

  
  
  @Input() _activeMenu: string = '';
  @Output() routeTypeEmit= new EventEmitter();

  public routeType = ''; 
  public routeInfo: any =[];
  // public vehicleInfo: any = {};
  pageNum=1;

  public vehicleBookingData = [

  
    // {
        
    //        "route": "Pallikaranai",
    //        "vehicle": "TN14Y7789",
    //        "location": "Velachery",
    //        "date": "12-3-2022",
    //        "totalSeat": "5",
    //        "filledSeat": "5",
    //      },
    //     {
    //        "route": "Pallikaranai",
    //        "vehicle": "TN14Y7789",
    //        "location": "Velachery",
    //        "date":" 12-3-2022",
    //        "totalSeat": "5",
    //        "filledSeat": "3",
    //      },
   
    //     {
          
    //        "route": "Pallikaranai",
    //        "vehicle": "TN14Y7789",
    //        "location": "Velachery",
    //        "date": "12-3-2022",
    //        "totalSeat": "20",
    //        "filledSeat": "8",
    //      },
    //  {
           
    //        "route": "Pallikaranai",
    //        "vehicle": "TN14Y7789",
    //        "location": "Velachery",
    //        "date": "12-3-2022",
    //        "totalSeat": "12",
    //        "filledSeat": "7",
    //      },
       ];

  /* Pagination */
  public userPaginationData:any;
  public showPagination:boolean = true;
  public paginationData = {
    page:1,
    limit:10,
    totalPage:1,
  };
  public filterData = {};


  public showTable:boolean = false;
  public noDataFoundEnable = false;
  public tableData:any = [];
  public cols:any = [
    { key: '#', display:'#'},
    { key: 'vehRegNo', display: 'Vehicle',
      config: {
        isVehicle:true,
      } 
    },
    { key: 'name', display: 'Route name',headerConfig:{ isDefault: true} },
    {
      key: 'tripDate', display: 'Date', config: {
        isDate: true,
        format: 'dd/MM/YYYY'
      }
    },
    { key:'filledSeat', key1:'seatCap', display: 'Seat count',
      config:{
        isSeatNumber: true,
      },
      headerConfig:{ isDefault: true}
    },
  ];
  public routeDetails:any = {};

  public matFormSize = '12px';
  public filterForm: FormGroup;
  public errorObject:any = {
    startDate: '',
    endDate: '',
  }
  public maxDate = new Date(new Date().setHours(24));
  public maxEndDate = new Date(new Date().setHours(24));
  public defaultMaxDate = new Date(new Date().setHours(24));
  public formSubmitted:boolean = false;
  public excelData:any = {};
  public showDownloadBtn:boolean = false;
  public exlNoDataFound:boolean = false;
  public vehExlData:any = [];

  constructor(
      private router: Router,
      private activatedRoute: ActivatedRoute,
      private api : ApiService,
      private storage:StorageService,
      private com :CommonServices,
      private fb : FormBuilder,
      private excel:ExcelExportService,
      private dateAdapter: DateAdapter<Date>
      ) {
          this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
          this.userPaginationData = this.storage.get('pagination') ? this.storage.get('pagination') : null;
  }

  
  ngOnInit(): void {
    this.getBookingDayConfigData();
    this.filterFormLoad();
    if(this.userPaginationData!=undefined && this.userPaginationData['tpmVehBookReport']){
      this.vehicleBasedBookingReport(this.userPaginationData['tpmVehBookReport']['page'], this.userPaginationData['tpmVehBookReport']['limit']);
    }
    else {
      setTimeout(()=>{ this.vehicleBasedBookingReport(); },1000);
    }

  }
  getBookingDayConfigData() {
    this.api.transportManagerGblSetBookingDayConfigList({}).then((res: any) => {
      if (res && res.status == 'success') {
        if(res.data && res.data[0]){
          let dayCount = res.data[0] && res.data[0].dayCount ? res.data[0].dayCount : 1;
          this.setDateMax(dayCount)
        }
      }
    }).catch((err) => {
      console.log('error', err);
    })
  }

  setDateMax(days){
    // let noOfHours = 24 * (+days);
    // this.maxDate = new Date(new Date().setHours(noOfHours));
    // this.maxEndDate = new Date(new Date().setHours(noOfHours));
    // this.defaultMaxDate = new Date(new Date().setHours(noOfHours));

    let currentMonthDays=new Date(new Date().getFullYear(), new Date().getMonth()+1, 0).getDate();
    let day=new Date().getDate();
    let balanceDaysInThisMonth=currentMonthDays-day;
    var d = new Date();
    let dt = new Date(d.setMonth(d.getMonth() + 1));
    let nextMonthDays=new Date(new Date(dt).getFullYear(), new Date(dt).getMonth()+1, 0).getDate();
    let totalDays=balanceDaysInThisMonth+nextMonthDays;
    var lastDate = new Date();
    lastDate.setDate(lastDate.getDate()+totalDays);
    this.maxDate = lastDate;
    this.maxEndDate = lastDate;
    this.defaultMaxDate = lastDate;
  }
  
  getRouteINfo(ids,resObj,pageObj){
    this.tableData = [];
    if(ids!='' && ids.length>0){
      let obj = { 
        // routeType:'openBooking',
        routeIDs:ids
      }
  
      this.api.selectedRoutes(obj).then(async(res:any)=>{
           if(res && res['status']=='success'){
               this.routeInfo = await this.com.getObjKeyValue(res['data'],'routeID','title');
               this.processTableData();
               this.processPagination(resObj,pageObj);
           }else{
             this.noDataFoundEnable = true;
             this.showTable = true;
           }
      });
   }else{
      this.noDataFoundEnable = true;
      this.showTable = true;
   }
  }
  vehicleBasedBookingReport(page=1,limit=10,filter?){
    this.noDataFoundEnable = false;
    this.showTable = false;
    let obj = {
      page:page,
      limit:limit,
    };
    if(filter){
      obj = { ...obj,...filter};
      this.filterData = { ...filter};
    }
       this.api.getVehicleBookingReports(obj).then((res:any)=>{
            if(res && res['status']=='success'){
              if(res['data'] && res['data'].length>0){
                this.vehicleBookingData = res['data'];
                let routeIDs= res['data'].map(itm => itm.routeID);
                routeIDs = Array.from(new Set(routeIDs)).join(',');
                this.getRouteINfo(routeIDs,res,obj);
              }
              else{
                this.tableData = [];
                this.showTable = true;
                this.noDataFoundEnable = true;
              }
            }else{
              this.tableData = [];
              this.showTable = true;
              this.noDataFoundEnable = true;
            }
       }).catch((err)=>{
         console.log('err',err);
       })
  }


processTableData(){ 
  this.showTable = false;
  this.tableData = this.vehicleBookingData.map((res:any)=>{
    if(res.filledSeat!=undefined && res.filledSeat >= 0){
      let obj = {
        name: this.routeInfo[res.routeID],
        vehRegNo:res.vehRegNo,
        tripDate:res.tripDate,
        filledSeat:res.filledSeat,
        seatCap:res.seatCap,
        routeID: res.routeID,
      }
      return obj;
    }
  });
  setTimeout(()=>{ this.showTable = true;this.noDataFoundEnable = true; },100);
}

processPagination(data,req){
  this.showTable = false;
  this.paginationData = {
    page:req.page,
    limit:req.limit,
    totalPage: this.getTotalCount(data.totCnt,req.limit),
  }
  this.storage.setData({pagination: { ...this.userPaginationData,'tpmVehBookReport':this.paginationData } });
  this.showTable = true;
}

getTotalCount(total,limit){
  let result:any = 1;  
  if(total/limit>0){
    result = total / limit;
    if(total % limit > 0) result++;
  }
  return Math.floor(result);
}

pagination(data){
  let filterObj = Object.keys(this.filterData).length > 0 ? this.filterData : false;
  this.vehicleBasedBookingReport(data.page,data.limit,filterObj);  // (data.page,data.limit,'search') use third parameter to get results for search inputs
}



  pageNavigate(path, $event) {

        
    const urlPath = 'organization/transport-manager/reports/';
    this.router.navigate([urlPath + 're-route']);
    setTimeout(()=>{
        this.router.navigate([urlPath + path]);
    },10);
    // this.router.navigate(['/heroes', { id: heroId }]);
}

filterFormLoad() {
  this.filterForm = this.fb.group({
    // vehicle: new FormControl('', [Validators.required]),
    search: new FormControl(''),
    startDate: new FormControl('', [Validators.required]),
    endDate: new FormControl('', [Validators.required]),
  });
}

dateFromAction(obj: any = {}, type) {
  obj.selectedDates.map((x: any) => {
    this.filterForm.controls[type].patchValue(x.getTime());
  });
}

setMaxDate() {
  let t_maxDate = new Date(this.filterForm.controls.startDate.value);

  //add a day to the date
  t_maxDate.setDate(t_maxDate.getDate() + 30);

  if (this.defaultMaxDate > t_maxDate) {
      this.maxEndDate = t_maxDate;
  }else{
    this.maxEndDate = this.defaultMaxDate;
  }

}

validation(data) {
  let objectKeys = Object.keys(this.errorObject);
  let isValid = true;
  for (let i = 0; i < objectKeys.length; i++) {
    let key = objectKeys[i];
    this.errorObject[key] = '';
    if (data[key] == '' || data[key] == undefined || data[key] == null || Number.isNaN(data[key]) || data.length <= 0) {
      this.errorObject[key] = key.split(/(?=[A-Z])/).join(" ").toLowerCase() + ' is required.';
      isValid = false;
    } else if ((key == 'startDate' || key == 'endDate')) {
      if (new Date(data.startDate).getTime() > new Date(data.endDate).getTime()) {
        isValid = false;
        this.errorObject['endDate'] = 'Invalid end date';
      }
    }
  }
  return isValid;
}

checkValidation(){
  let obj = {
    startDate: new Date(this.filterForm.value.startDate).getTime(),
    endDate: new Date(this.filterForm.value.endDate).getTime(),
  }
  if(this.formSubmitted) this.validation(obj);
}

onSubmit() {
  // console.log(this.sosForm.value);
  this.formSubmitted = true;
  let checkObj = {
    startDate: new Date(this.filterForm.value.startDate).getTime(),
    endDate: new Date(this.filterForm.value.endDate).getTime(),
  }
  let isValid = this.validation(checkObj);
  console.log(isValid);
  if (isValid) {
    let obj = {
      startDate: new Date(new Date(this.filterForm.value.startDate).setHours(0)).getTime(),
      endDate: new Date(new Date(this.filterForm.value.endDate).setHours(23,59,59)).getTime(),
    }
    if(this.filterForm.value.search!='') obj['search'] = this.filterForm.value.search;
    this.getVehicleExlReports(obj);
    this.vehicleBasedBookingReport(1,this.paginationData.limit,obj);
  }
}

getVehicleExlReports(obj){
  this.showDownloadBtn = false;
  this.vehExlData = [];
  this.routeDetails = {};
  this.api.getVehicleBookingExlReports(obj).then(async (res:any)=>{
    if(res && res.data && res.data.length>0){
      this.vehExlData = res.data.filter((item)=>{
        if(item.filledSeat!=undefined && item.filledSeat >= 0){ return item; }
      });
      let routeRestults = await this.processRouteData(res.data);
      if(this.routeDetails && Array.isArray(routeRestults) && routeRestults.length>0){
        routeRestults.map((item)=>{
          if(item.routeID){
            this.routeDetails[item.routeID] = item;
          }
        })
        this.exportToExcel();
      }
    }else{
      this.exlNoDataFound = true;
    }
  }).catch((err)=>{ console.log(err);this.exlNoDataFound = true; })
}

async processRouteData(data){

  return new Promise(async (resolve, reject) => {
    try {
      if(data && data.length>0){
        let routeID:any = data.map(itm => itm.routeID);
        let routeIDs = Array.from(new Set(routeID)).join(',');
        let routeData  = [];
        if(routeID.length > 100){
          let obj = { routeIDs };
          let ping = 1, i = 0;
          while (ping) {
            obj['page'] = i + 1;
            i++;
            let results = await this.api.selectedRoutes(obj).catch((e)=>{ console.log('Route Data retriving issues')});
            if (results && results['status'] == 'success') {
              if (results['data'].length <= 0) ping = 0;
              else routeData.push(results['data']);
            }
            else ping = 0;

          }
        }
        else{
          let results = await this.api.selectedRoutes({  routeIDs }).catch((e)=>{ console.log('Route Data retriving issues')});
          if (results && results['status'] == 'success') {
            routeData = results['data'];
          }
        }
        resolve(routeData);
      }
      else resolve([]);
    } catch (error) {
        reject(error);
    }
});

}

async exportToExcel() {
  let data = [];

  const startDate = new Date(this.filterForm.value.startDate + '');
  const endDate = new Date(new Date(this.filterForm.value.endDate + '').setHours(23,59,59));

  for (let i = 0; i < this.vehExlData.length; i++) {
    let item = this.vehExlData[i];
    try {
        let res = {  
          value:[
            i + 1,
            item.vehRegNo ? item.vehRegNo : '---',
            item.routeID && this.routeDetails[item.routeID] && this.routeDetails[item.routeID]['title'] ? this.com.convertTitleCase(this.routeDetails[item.routeID]['title']) : '---',
            item.tripDate ? this.com.timestampToDate(new Date(item.tripDate).getTime(), 'DMY') : '--/--/----',
            `${(item.filledSeat!=undefined || item.filledSeat>=0) ? item.filledSeat : '--'}/${(item.seatCap || item.seatCap==0) ? item.seatCap : '--'}`
          ],
          alignment: [
            {cell:`A${i+6}`, value: { vertical: 'top', horizontal: 'right' }}, 
            {cell:`E${i+6}`, value: { vertical: 'top', horizontal: 'right' }}
          ]
        };
        data.push(res);

    } catch (err) {
      console.log(err);
    }
  }
  if (data.length > 0) {

    let customizedData = [];

    let titleRow = {
      value: ['Vehicle Booking Report'],
      mergeCells: ["A1:E2"],
      font: {
        name: 'Corbel', family: 4, size: 16, bold: true,
        color: { argb: 'FFFFFFFF' },
      },
      alignment: {
        cell: "A1", value: { vertical: 'middle', horizontal: 'center' },
      },
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '966462AF' },
        bgColor: { argb: '966462AF' }
      },
    }

    customizedData.push(titleRow);

    let subtitleRow = {
      value: ["Start Date  : " + this.com.timestampToDate(new Date(startDate).getTime(), 'DMY') + "\n" +
              "End Date    : " + this.com.timestampToDate(new Date(endDate).getTime(), 'DMY') ],
      font: { name: 'Corbel', family: 4, size: 12, },
      mergeCells: ["A3:E4"],
    }

    customizedData.push(subtitleRow);

    let headerRow = 
    {
      value: ['S No','Reg no', 'Route name' , 'Date', 'Seat count'],
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      },
      font: { bold: true },
      border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    }
    customizedData.push(headerRow);

    customizedData = [ ...customizedData,...data];

    const excelInfo = {
      customizedData: customizedData,
      data: {
        columWith: [{ colNo: 2, width: 15 }, { colNo: 3, width: 20 }, { colNo: 4, width: 15 } ,  {colNo: 5, width: 15 }]
      }
    };

    if (this.excelData['Vehicle_Booking_Report'] == undefined) { this.excelData['Vehicle_Booking_Report'] = {}; }

    this.excelData['Vehicle_Booking_Report'] = excelInfo;
    this.exlNoDataFound = false;
    this.showDownloadBtn = true;
  }
  else this.exlNoDataFound = true;

}

downloadExlReport() {
  this.excel.generateExcel(this.excelData, 'Vehicle_Booking_Report' + this.com.timestampToDate(new Date().getTime(),'DMY' )  + '.xlsx');
}




}
